import * as React from 'react';
import { useState } from 'react';
import * as styles from './collapsible-sidebar.module.scss';
import MaterialIcon from '@material/react-material-icon';

interface Props {
  initialCollapse: boolean;
  sidebarClass: string;
  collapsedClass: string;
  children: any;
  iconClass?: string;
  arrowOpenIcon?: boolean;
  onCollapseToggle: (collapseState: boolean) => void;
}

const CollapsibleSidebar = (props: Props) => {
  const [collapsed, setCollapsed] = useState(props.initialCollapse);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    props.onCollapseToggle(!collapsed);
  };

  return (
    <div className={`${props.sidebarClass} ${collapsed ? props.collapsedClass : ''} ${styles.collapsibleSidebar} `}>
      <div className={`${props.iconClass ? props.iconClass : ''} ${styles.collapseButton}`} onClick={toggleCollapse}>
        {!collapsed ? (
          <MaterialIcon icon="keyboard_arrow_left" className={styles.arrowLeft} />
        ) : props.arrowOpenIcon ? (
          <MaterialIcon icon="keyboard_arrow_right" className={styles.arrowLeft} />
        ) : (
          <MaterialIcon icon="menu" className={styles.menu} />
        )}
      </div>
      {props.children}
    </div>
  );
};
export default CollapsibleSidebar;
